import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, className = "", as: As = "div", ...rest }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setVisible(true);
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);

    return (
        <As
            ref={ref}
            className={className}
            {...rest}
            style={{
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(14px)",
                transition: `opacity 600ms ease-out ${delay}ms, transform 600ms ease-out ${delay}ms`,
            }}
        >
            {children}
        </As>
    );
};

export default Reveal;
